export const UPDATE_OPERATOR_ACCOUNT_DETAILS =
  "UPDATE_OPERATOR_ACCOUNT_DETAILS";

export const UPDATE_OPERATOR_ADDRESS_DETAILS =
  "UPDATE_OPERATOR_ADDRESS_DETAILS";

export const OPERATOR_SIGN_UP_REQUEST = "OPERATOR_SIGN_UP_REQUEST";
export const OPERATOR_SIGN_UP_SUCCESS = "INVITE_DRIVER_SUCCESS";
export const OPERATOR_SIGN_UP_FAILURE = "OPERATOR_SIGN_UP_FAILURE";

export const OPERATOR_FILE_UPLOAD_REQUEST = "OPERATOR_FILE_UPLOAD_REQUEST";
export const OPERATOR_FILE_UPLOAD_SUCCESS = "OPERATOR_FILE_UPLOAD_SUCCESS";
export const OPERATOR_FILE_UPLOAD_FAILURE = "OPERATOR_FILE_UPLOAD_FAILURE";
export const G2_OPERATOR_SIGNUP_REQUEST = "G2_OPERATOR_SIGNUP_REQUEST";
export const PROMOTE_TO_OWNER_FROM_DRIVER_REQUEST =
  "PROMOTE_TO_OWNER_FROM_DRIVER_REQUEST";
export const PROMOTE_TO_OWNER_FROM_DRIVER_REQUEST_FAILURE =
  "PROMOTE_TO_OWNER_FROM_DRIVER_REQUEST_FAILURE";
